module.exports = __webpack_public_path__ + "media/images/icons/icon_mypage_donation_count_white-3e73d507c14ad67d429392d847d6e1bc.svg";